import { render, staticRenderFns } from "./PromotionPagesTable.vue?vue&type=template&id=84b06eb0&"
import script from "./PromotionPagesTable.vue?vue&type=script&lang=js&"
export * from "./PromotionPagesTable.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPagesTable.vue?vue&type=style&index=0&id=84b06eb0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports